import React, { FC } from 'react'

import { IconType } from '../../common/types'

const NucUser: FC<IconType> = ({ iconColor = 'currentColor', ...svgProps }) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...svgProps}
    >
      <path
        d='M8 9.25C10.4609 9.25 12.5 7.24609 12.5 4.75C12.5 2.28906 10.4609 0.25 8 0.25C5.50391 0.25 3.5 2.28906 3.5 4.75C3.5 7.24609 5.50391 9.25 8 9.25ZM9.75781 10.9375H6.20703C2.83203 10.9375 0.125 13.6797 0.125 17.0547C0.125 17.7227 0.652344 18.25 1.32031 18.25H14.6445C15.3125 18.25 15.875 17.7227 15.875 17.0547C15.875 13.6797 13.1328 10.9375 9.75781 10.9375Z'
        fill={iconColor}
      />
    </svg>
  )
}

export default NucUser
